import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_sales_order_export_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { order_id: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, HasChildren?: boolean, PackagedAmount?: number, ParentOrderLine?: { OrderId?: number, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }, Order?: { LookupCode?: string, OwnerReference?: string, VendorReference?: string }, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { order_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, HasChildren?: boolean, PackagedAmount?: number, ParentOrderLine?: { OrderId?: number, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }, Order?: { LookupCode?: string, OwnerReference?: string, VendorReference?: string }, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { order_id: number, $keys: { OrderId?: number, LineNumber?: number }[] }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, HasChildren?: boolean, PackagedAmount?: number, ParentOrderLine?: { OrderId?: number, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }, Order?: { LookupCode?: string, OwnerReference?: string, VendorReference?: string }, Material?: { LookupCode?: string }, MaterialPackagingLookup?: { UpcCode?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      order_id: number    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
      return false;
    }
}
